import { Money } from '@commercetools/frontend-domain-types/product';
import { CyberSourcePaymentDetails } from 'components/commercetools-ui/organisms/checkout/provider/payment/types';
import { PaymentDraftExtended } from '../../../../../../../../../../types/cart/PaymentExtended';
import {
  BREAD_PAYMENT_PROVIDER,
  CYBERSOURCE_CARDS_TYPES_MAP,
  CYBERSOURCE_PAYMENT_PROVIDER,
  PAYMENT_METHODS,
} from '../../../../../../../../../helpers/constants/payment';

export const getPayloadForAddPayment = (
  cartTotal: Money,
  custom: {
    [x in
      | 'cyberSourceCaptureContext'
      | 'cyberSourceToken'
      | 'cyberSourcePaymentInstrumentId'
      | 'saveCyberSourcePaymentInstrument']?: string | boolean;
  },
): PaymentDraftExtended => {
  return {
    paymentProvider: CYBERSOURCE_PAYMENT_PROVIDER,
    paymentMethod: PAYMENT_METHODS.CYBERSOURCE_CREDIT_CARD,
    amountPlanned: cartTotal,
    paymentStatus: '',
    custom,
  };
};

export const getPayloadForUpdatePayment = (data: PaymentDraftExtended, token: string) => {
  return {
    ...data,
    custom: {
      fields: {
        cyberSourceToken: token,
      },
    },
  };
};
export const getPayloadForBreadAddPayment = (breadTransactionId: string, cartTotal: Money): PaymentDraftExtended => {
  return {
    paymentProvider: BREAD_PAYMENT_PROVIDER,
    paymentMethod: PAYMENT_METHODS.BREADPAYMENT,
    amountPlanned: cartTotal,
    paymentStatus: 'SUCCESS',
    custom: {
      breadTransactionId,
    },
  };
};

export const decodeCyberSourceToken = (token: string): CyberSourcePaymentDetails | undefined => {
  try {
    const tokenArr = token.split('.');
    const tokenObj = JSON.parse(atob(tokenArr.length > 1 ? tokenArr[1] : tokenArr[0]));
    if (tokenObj?.content?.paymentInformation) {
      const cardType: string = tokenObj?.content?.paymentInformation?.card?.number?.detectedCardTypes?.[0];

      return {
        brand: cardType ? (CYBERSOURCE_CARDS_TYPES_MAP as any)[cardType] : undefined,
        number: tokenObj?.content?.paymentInformation?.card?.number?.maskedValue
          ?.replace('XXXXXXXXXXXX', '****-')
          ?.replace('XXXXXXXXXXX', '****-'),
        expiryMonth: tokenObj?.content?.paymentInformation?.card?.expirationMonth?.value,
        expiryYear: tokenObj?.content?.paymentInformation?.card?.expirationYear?.value?.slice(2),
      };
    }
  } catch (error) {
    console.log(error);
    return undefined;
  }
  return undefined;
};

export const handleCyberSourceErrors = (
  errorObj: any,
  setIsCardNumberValid: (valid: boolean) => void,
  setIsCVNValid: (valid: boolean) => void,
  setIsPaymentError: (valid: boolean) => void,
  setIsExpDateValid?: (valid: boolean) => void,
) => {
  setIsCardNumberValid(true);
  setIsCVNValid(true);
  setIsPaymentError(false);
  if (setIsExpDateValid) setIsExpDateValid(true);
  switch (errorObj.reason) {
    case 'CREATE_TOKEN_VALIDATION_FIELDS':
    case 'CREATE_TOKEN_VALIDATION_SERVERSIDE':
      errorObj.details?.map((errDetail: any) => {
        switch (errDetail.location) {
          case 'number':
            setIsCardNumberValid(false);
            break;
          case 'securityCode':
            setIsCVNValid(false);
            break;
          case 'expirationYear':
          case 'expirationMonth':
            if (setIsExpDateValid) setIsExpDateValid(false);
            break;
        }
      });
      break;
    case 'CREATE_TOKEN_VALIDATION_PARAMS':
    default:
      setIsCardNumberValid(true);
      setIsCVNValid(true);
      setIsPaymentError(true);
      if (setIsExpDateValid) setIsExpDateValid(true);
      break;
  }
};

const parseCyberSourceCaptureContextForUrl = (token: string): [string, string] => {
  const decoded = JSON.parse(Buffer.from(token?.split('.')[1], 'base64').toString());
  const url = decoded?.ctx[0]?.data?.clientLibrary || '';
  const integrity = decoded?.ctx[0]?.data?.clientLibraryIntegrity || '';
  return [url, integrity];
};

export const createScriptTagForCybersource = (captureContext: string): HTMLScriptElement => {
  const script = document.createElement('script');
  const [url, integrity] = parseCyberSourceCaptureContextForUrl(captureContext);
  script.src = url;
  script.integrity = integrity;
  script.crossOrigin = 'anonymous';
  script.async = true;
  return script;
};

export const formatCardNumber = (number: string) => {
  const v = number.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];
  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }
  if (parts.length) {
    return parts.join(' ');
  } else {
    return number;
  }
};
